import script from "./MediaPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaPreview.vue?vue&type=script&lang=ts&setup=true"

import "./MediaPreview.vue?vue&type=style&index=0&id=8be11b68&lang=scss"

const __exports__ = script;

export default __exports__